export default __webpack_public_path__ + "static/media/eventopsLogoWhite.5a4ef902.png";